import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import _ from 'lodash';

Vue.use(Vuex);

const miner_axios = axios.create();
const kts_axios = axios.create();

kts_axios.defaults.baseURL = process.env.VUE_APP_API_URL;

if (localStorage.getItem('access_token')) {
  kts_axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token')
}

kts_axios.interceptors.response.use(undefined, function(err) {
  if (err.response.status === 401) {
    store.dispatch('logout');
    window.myApp.$f7.preloader.show();
    location.reload();
    /*window.myApp.$f7.views.main.router.navigate('/dang-nhap', {
        force: true
    });*/
  }
  else if (err.response.status === 503) {
    // store.dispatch('logout');
    window.myApp.$f7.views.main.router.navigate('/bao-tri', {
      force: true
    });
  }
  return Promise.reject(err);
});

export const store = new Vuex.Store({
  state: {
    app_version: '2.1.8b',
    bot_link: process.env.VUE_APP_KIOTSO_BOT,
    access_token: localStorage.getItem('access_token') || '',
    user_info: (localStorage.getItem('user_info')) ? JSON.parse(localStorage.getItem('user_info')) : {},
    onesignal_id: (new URLSearchParams(window.location.search)).get('onesignal_push_id'),
    referal: (new URLSearchParams(window.location.search)).get('ref'),
    is_ok: true,
    channels: {
      mb: 'Miền bắc',
      hn: 'Hà Nội',
      tp: 'TP.HCM',
      hcm: 'TP.HCM',
      dt: 'Đồng Tháp',
      cm: 'Cà Mau',
      btr: 'Bến Tre',
      vt: 'Vũng Tàu',
      bl: 'Bạc Liêu',
      bli: 'Bạc Liêu',
      dn: 'Đồng Nai',
      ct: 'Cần Thơ',
      st: 'Sóc Trăng',
      tn: 'Tây Ninh',
      ag: 'An Giang',
      bth: 'Bình Thuận',
      vl: 'Vĩnh Long',
      bd: 'Bình Dương',
      tv: 'Trà Vinh',
      la: 'Long An',
      bp: 'B.Phước',
      hg: 'Hậu Giang',
      tg: 'Tiền Giang',
      kg: 'Kiên Giang',
      dl: 'Đà Lạt',
      tb: 'Thái Bình',
      nd: 'Nam Định',
      hp: 'Hải Phòng',
      bn: 'Bắc Ninh',
      qn: 'Quảng Ninh',
      tth: 'Thừa T. Huế',
      hue: 'Thừa T. Huế',
      py: 'Phú Yên',
      dlk: 'Đắk Lắk',
      qnm: 'Quảng Nam',
      dng: 'Đà Nẵng',
      kh: 'Khánh Hòa',
      bdi: 'Bình Định',
      qt: 'Quảng Trị',
      qb: 'Quảng Bình',
      gl: 'Gia Lai',
      nt: 'Ninh Thuận',
      qng: 'Quảng Ngãi',
      dno: 'Đắk Nông',
      kt: 'Kon Tum'
    },
    selected_customer: {},
    selected_drawdate: new Date(),
    customers: [],
    shortcodes: [],
    friends: [],
    isset_region: localStorage.getItem('isset_region') ? parseInt(localStorage.getItem('isset_region')) : 0,
    exchange: {},
    dark_mode: localStorage.getItem('dark_mode') ? parseInt(localStorage.getItem('dark_mode')) : 0,
    wallets: (localStorage.getItem('wallets')) ? JSON.parse(localStorage.getItem('wallets')) : [],
    selected_wallet: {},
    coin_configs: {
      ETH: {
        point: 1000000000,
        numeral: '0.00000'
      },
      ETC: {
        point: 1000000000,
        numeral: '0.00000'
      },
      RVN: {
        point: 100000000,
        numeral: '0.00'
      }
    },
    bots: [],
    adv_popup_showed: localStorage.getItem('adv_popup_showed') || ''
  },
  mutations: {
    ADD_WALLET(state, payload) {
      state.wallets.push(payload);
      localStorage.setItem('wallets', JSON.stringify(state.wallets));
    },
    EDIT_WALLET(state, payload) {
      let idx = _.findIndex(state.wallets, payload.old_data);
      if (idx >= 0) {
        state.wallets[idx] = payload.new_data;
        localStorage.setItem('wallets', JSON.stringify(state.wallets));
      }
    },
    REMOVE_WALLET(state, payload) {
      state.wallets = _.reject(state.wallets, { pool: payload.pool, coin: payload.coin, address: payload.address });
      localStorage.setItem('wallets', JSON.stringify(state.wallets));
    },
    TOGGLE_DARK_MODE(state, payload) {
      localStorage.setItem('dark_mode', payload.dark_mode);
      state.dark_mode = payload.dark_mode;
    },
    AUTH_SUCCESS(state, payload) {
      state.access_token = payload.access_token;
      localStorage.setItem('access_token', payload.access_token);
      kts_axios.defaults.headers.common['Authorization'] = 'Bearer ' + payload.access_token;
    },
    AUTH_LOGOUT(state) {
      state.access_token = '';
      state.user_info = {};
      state.selected_customer = [];
      state.selected_drawdate = [];
      state.customers = [];
      state.shortcodes = [];
      state.dark_mode = 0;

      localStorage.setItem('access_token', '');
      localStorage.setItem('user_info', JSON.stringify(state.user_info));
      localStorage.setItem('isset_region', 0);
      localStorage.setItem('dark_mode', 0);
    },
    AUTH_INFO(state, payload) {
      state.user_info = payload;
      localStorage.setItem('user_info', JSON.stringify(payload));
    },
    AUTH_INFO_CONFIG(state, payload) {
      state.user_info.user_configs = payload;
      localStorage.setItem('user_info', JSON.stringify(state.user_info));
    },
    UPDATE_FONT_SIZE(state) {
      let font_size = _.isUndefined(state.user_info.user_configs.font_size) ? 14 : state.user_info.user_configs.font_size;
      let input_size = parseInt(font_size) >= 16 ? font_size : 16;
      let root = document.documentElement;

      root.style.setProperty('--f7-table-head-font-size', font_size + "px");
      root.style.setProperty('--f7-table-body-font-size', font_size + "px");
      root.style.setProperty('--f7-table-footer-font-size', font_size + "px");
      root.style.setProperty('--f7-table-input-font-size', font_size + "px");
      root.style.setProperty('--f7-font-size', font_size + "px");
      root.style.setProperty('--f7-input-font-size', input_size + "px");
      root.style.setProperty('--f7-card-font-size', font_size + "px");
      root.style.setProperty('--f7-block-title-font-size', (font_size + 2) + "px");
      root.style.setProperty('--f7-block-header-font-size', (font_size + 2) + "px");

      if(font_size >= 18){
        root.style.setProperty('--f7-customer-detail-top', "380px");
      } else if (font_size >= 16) {
        root.style.setProperty('--f7-customer-detail-top', "350px");
      } else {
        root.style.setProperty('--f7-customer-detail-top', "320px");
      }
    },
    UPDATE_CUSTOMERS(state, payload) {
      state.customers = payload;
    },
    UPDATE_SHORTCODES(state, payload) {
      state.shortcodes = payload;
    },
    UPDATE_FRIENDS(state, payload) {
      state.friends = payload;
    },
    UPDATE_MENTOR_CODE(state, payload) {
      state.user_info.mentor_code = payload.mentor_code;
      state.user_info.mobile = payload.mobile;

      localStorage.setItem('user_info', JSON.stringify(state.user_info));
    },
    UPDATE_QUESTION(state, payload) {
      state.user_info.secret_question_1 = payload.secret_question_1;
      state.user_info.secret_question_2 = payload.secret_question_2;

      localStorage.setItem('user_info', JSON.stringify(state.user_info));
    },
    UPDATE_ISSET_REGION(state, payload) {
      state.isset_region = payload;

      localStorage.setItem('isset_region', payload);
    },
    UPDATE_EXCHANGE(state, payload) {
      state.exchange = payload;
    },
    UPDATE_BOTS(state, payload) {
      let bots = [];

      _.each(payload.data, (bot) => {
        bot.is_new = 0;
        let idx = _.findIndex(state.bots, {id: bot.id});

        if(idx >= 0){
          bot.is_new = state.bots[idx].is_new;

          if(!_.isEqual(state.bots[idx].stat_messages, bot.stat_messages)){
            bot.is_new = 1;
          }
        }
        bots.push(bot);
      });

      state.bots = bots;
    },
    UPDATE_ADV_POPUP(state){
      state.adv_popup_showed = new Date().toISOString().slice(0, 10);
      localStorage.setItem('adv_popup_showed', state.adv_popup_showed);
    }
  },
  actions: {
    toggleDarkMode({ commit, state }) {
      if (state.dark_mode === 1) {
        document.getElementsByTagName('html')[0].classList.remove('theme-dark');
      }
      else{
        document.getElementsByTagName('html')[0].classList.add('theme-dark');
      }

      commit('TOGGLE_DARK_MODE', { dark_mode: (state.dark_mode ? 0 : 1) });
    },
    setDarkMode({ state }) {
      if (state.dark_mode === 1) {
        document.getElementsByTagName('html')[0].classList.add('theme-dark');
      }
      else{
        document.getElementsByTagName('html')[0].classList.remove('theme-dark');
      }
    },
    /* eslint-disable */
    async addWallet({ commit }, payload) {
      try{
        if (_.isUndefined(payload.pool) || _.isEmpty(payload.pool)) {
          throw new Error('Please select Pool');
        }
        if (_.isUndefined(payload.coin) || _.isEmpty(payload.coin)) {
          throw new Error('Please select Coin');
        }
        if (_.isUndefined(payload.name) || _.isEmpty(payload.name)) {
          throw new Error('Please input Wallet Name');
        }
        if (_.isUndefined(payload.address) || _.isEmpty(payload.address)) {
          throw new Error('Please input Wallet Address');
        }
        commit('ADD_WALLET', payload);
        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data) && !_.isUndefined(err.response.data.errors)) ? _.first(_.first(_.toPairs(err.response.data.errors))[1]) : 'An error has occurred';
      }
    },
    async editWallet({ commit }, payload) {
      try{
        if (_.isUndefined(payload.new_data.pool) || _.isEmpty(payload.new_data.pool)) {
          throw new Error('Please select Pool');
        }
        if (_.isUndefined(payload.new_data.coin) || _.isEmpty(payload.new_data.coin)) {
          throw new Error('Please select Coin');
        }
        if (_.isUndefined(payload.new_data.name) || _.isEmpty(payload.new_data.name)) {
          throw new Error('Please input Wallet Name');
        }
        if (_.isUndefined(payload.new_data.address) || _.isEmpty(payload.new_data.address)) {
          throw new Error('Please input Wallet Address');
        }
        commit('EDIT_WALLET', payload);
        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data) && !_.isUndefined(err.response.data.errors)) ? _.first(_.first(_.toPairs(err.response.data.errors))[1]) : 'An error has occurred';
      }
    },
    async removeWallet({ commit }, payload) {
      try{
        if (_.isUndefined(payload.pool) || _.isEmpty(payload.pool)) {
          throw new Error('Please select Pool');
        }
        if (_.isUndefined(payload.coin) || _.isEmpty(payload.coin)) {
          throw new Error('Please select Coin');
        }
        if (_.isUndefined(payload.address) || _.isEmpty(payload.address)) {
          throw new Error('Please input Wallet Address');
        }
        commit('REMOVE_WALLET', payload);
        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data) && !_.isUndefined(err.response.data.errors)) ? _.first(_.first(_.toPairs(err.response.data.errors))[1]) : 'An error has occurred';
      }
    },
    async getCoinInfo({ commit }, payload) {
      try{
        let url = 'https://currencies.2miners.com/api/v1/ticker/' + payload + '/';
        let result = await miner_axios.get(url);

        return result.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data) && !_.isUndefined(err.response.data.errors)) ? _.first(_.first(_.toPairs(err.response.data.errors))[1]) : 'An error has occurred';
      }
    },
    async get2MinersWalletInfo({ commit }, payload) {
      try{
        let url = '';
        if (payload.coin === 'ETC') {
          url = 'https://etc.2miners.com/api/accounts/' + payload.address
        }
        else if (payload.coin === 'RVN') {
          url = 'https://rvn.2miners.com/api/accounts/' + payload.address
        }
        else if (payload.coin === 'ETH') {
          url = 'https://ethw.2miners.com/api/accounts/' + payload.address
        }
        else{
          throw new Error('Not support yet');
        }

        let result = await miner_axios.get(url);

        return result.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data) && !_.isUndefined(err.response.data.errors)) ? _.first(_.first(_.toPairs(err.response.data.errors))[1]) : 'No miner data available';
      }
    },
    async get2MinersWalletHashrate({ commit }, payload) {
      try{
        let url = '';
        if (payload.coin === 'ETC') {
          url = 'https://etc.2miners.com/api/accounts/' + payload.address + '/hashrates/5m'
        }
        else if (payload.coin === 'RVN') {
          url = 'https://rvn.2miners.com/api/accounts/' + payload.address + '/hashrates/5m'
        }
        else if (payload.coin === 'ETH') {
          url = 'https://ethw.2miners.com/api/accounts/' + payload.address + '/hashrates/5m'
        }
        else{
          throw new Error('Not support yet');
        }

        let result = await miner_axios.get(url);

        return result.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data) && !_.isUndefined(err.response.data.errors)) ? _.first(_.first(_.toPairs(err.response.data.errors))[1]) : 'No miner data available';
      }
    },
    async getEthermineWalletInfo({ commit }, payload) {
      try{
        let url = '';
        if (payload.coin === 'ETH') {
          url = 'https://api.ethermine.org/miner/' + payload.address + '/dashboard'
        }
        else if (payload.coin === 'ETC') {
          url = 'https://api-etc.ethermine.org/miner/' + payload.address + '/dashboard'
        }
        else if (payload.coin === 'RVN') {
          url = 'https://api-ravencoin.flypool.org/miner/' + payload.address + '/dashboard'
        }
        else{
          throw new Error('Not support yet');
        }

        let result = await miner_axios.get(url);

        return result.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data) && !_.isUndefined(err.response.data.errors)) ? _.first(_.first(_.toPairs(err.response.data.errors))[1]) : 'No miner data available';
      }
    },
    async getEtherminePayoutsInfo({ commit }, payload) {
      try{
        let url = '';
        if (payload.coin === 'ETH') {
          url = 'https://api.ethermine.org/miner/' + payload.address + '/dashboard/payouts'
        }
        else if (payload.coin === 'ETC') {
          url = 'https://api-etc.ethermine.org/miner/' + payload.address + '/dashboard/payouts'
        }
        else if (payload.coin === 'RVN') {
          url = 'https://api-ravencoin.flypool.org/miner/' + payload.address + '/dashboard/payouts'
        }
        else{
          throw new Error('Not support yet');
        }

        let result = await miner_axios.get(url);

        return result.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data) && !_.isUndefined(err.response.data.errors)) ? _.first(_.first(_.toPairs(err.response.data.errors))[1]) : 'No miner data available';
      }
    },
    async login({ commit, dispatch, state }, payload) {
      try{
        let result = await kts_axios.post('auth/login', {
          username: payload.username,
          password: payload.password,
          notification_id: state.onesignal_id
        });

        commit('AUTH_SUCCESS', result.data);
        await dispatch('getMe');

        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? _.first(_.first(_.toPairs(err.response.data.errors))[1]) : 'Sai tên đăng nhập hoặc mật khẩu!';
      }
    },
    async logout({ commit }) {
      try{
        kts_axios.get('auth/logout');
        commit('AUTH_LOGOUT');
      }catch(err){
        commit('AUTH_LOGOUT');
      }
    },
    async register({ commit }, payload) {
      try{
        await kts_axios.post('auth/signup', payload);

        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async forgotPassword({ commit }, payload) {
      try{
        let response = await kts_axios.post('auth/forgot-password', payload);
        return response.data.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getQuestions({ commit }, payload) {
      try{
        let response = await kts_axios.get(`auth/few-info/${payload.username}`);
        return response.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getMe({ commit, state }) {
      try{
        if (_.isEmpty(state.access_token)) {
          return false;
        }

        let result = await kts_axios.get('auth/info');

        commit('AUTH_INFO', result.data.data.message);
        commit('UPDATE_FONT_SIZE');

        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async changeMeConfig({ commit }, payload) {
      try{
        commit('UPDATE_FONT_SIZE', payload);

        await kts_axios.patch('user/save-config', payload);

        commit('AUTH_INFO_CONFIG', payload);

        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async changePassword({ commit }, payload) {
      try{
        await kts_axios.post('auth/reset_password', payload);

        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async changePasswordLevel2({ commit }, payload) {
      try{
        await kts_axios.post('auth/update_password_level2', payload);

        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async changePasswordSimple({ commit }, payload) {
      try{
        await kts_axios.post('mentor/set-password', payload);

        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async promoteSimpleAccount({ commit }, payload) {
      try{
        await kts_axios.post('mentor/promote-simple-account', payload);

        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? err.response.data.errors[_.keys(err.response.data.errors)] : 'Có lỗi xảy ra';
      }
    },
    async setFranchisePercent({ commit }, payload) {
      try{
        await kts_axios.post('mentor/set-franchise-percent', payload);

        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? err.response.data.errors[_.keys(err.response.data.errors)] : 'Có lỗi xảy ra';
      }
    },
    async generateOTPchangePasswordLevel2() {
      try{
        await kts_axios.get('auth/get-otp-password-level2');

        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getCustomers({ commit }, payload) {
      try{
        let result = await kts_axios.get('customers', {
          params: payload
        });

        commit('UPDATE_CUSTOMERS', result.data.data.data);

        return result.data.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getCustomerDetail({ commit }, payload) {
      try{
        let result = await kts_axios.get('customers/' + payload.id);

        return result.data.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async createCustomer({ commit }, payload) {
      try{
        let result = await kts_axios.post('customers', payload.config_deal, {
          params: {
            fullname: payload.fullname,
            mobile: payload.mobile,
            type: payload.type
          }
        });

        return result.data.data.id;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async editCustomer({ commit }, payload) {
      try{
        await kts_axios.patch('customers/' + payload.id, payload.config_deal, {
          params: {
            fullname: payload.fullname,
            mobile: payload.mobile,
            type: payload.type
          }
        });

        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async removeCustomer({ commit }, payload) {
      try{
        await kts_axios.delete('customers/' + payload.id);

        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async changeCustomerConfig({ commit }, payload) {
      try{
        await kts_axios.patch('customers/save-overpoint-config', payload);

        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async changeCustomerUIConfig({ commit }, payload) {
      try{
        await kts_axios.patch('customers/save-ui-config', payload);

        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async addMessage({ commit }, payload) {
      try{
        await kts_axios.post('messages/store_message', payload);
        return true;
      }catch(err){
        let error_message = (!_.isUndefined(err.response.data.errors)) ? _.first(_.first(_.toPairs(err.response.data.errors))[1]) : 'Có lỗi xảy ra';
        let index = (!_.isUndefined(err.response.data.message)) ? err.response.data.message.index : 0;
        let length = (!_.isUndefined(err.response.data.message)) ? err.response.data.message.length : 0;
        error_message = (!_.isUndefined(err.response.data.message)) ? err.response.data.message.message : error_message;

        throw {
          message: error_message,
          index: index,
          length: length
        };
      }
    },
    async editMessage({ commit }, payload) {
      try{
        await kts_axios.post('messages/store_message', payload);
        return true;
      }catch(err){
        let error_message = (!_.isUndefined(err.response.data.errors)) ? _.first(_.first(_.toPairs(err.response.data.errors))[1]) : 'Có lỗi xảy ra';
        let index = (!_.isUndefined(err.response.data.message)) ? err.response.data.message.index : 0;
        let length = (!_.isUndefined(err.response.data.message)) ? err.response.data.message.length : 0;
        error_message = (!_.isUndefined(err.response.data.message)) ? err.response.data.message.message : error_message;

        throw {
          message: error_message,
          index: index,
          length: length
        };
      }
    },
    async parseMessage({ commit }, payload) {
      try{
        let result = await kts_axios.post('messages/parse', {
          play_style: payload.play_style,
          region: payload.region,
          content_original: payload.content,
          customer_id: payload.customer_id,
        });
        return result.data.data.parsed_content;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async checkMessage({ commit }, payload) {
      try{
        let result = await kts_axios.post('messages/check', {
          content_original: payload.content,
          region: payload.region,
          date: payload.drawdate,
          n_syntax: payload.n_syntax,
          play_style: payload.play_style,
          customer_id: payload.customer_id,
        });

        if (!!result.data.data.message) {
          throw {
            message: result.data.data.message,
            index: result.data.data.info.current_index,
            length: result.data.data.info.error_input.length
          };
        }

        return result.data.data;
      }catch(err){
        let index = (!_.isUndefined(err.index)) ? err.index : 0;
        let length = (!_.isUndefined(err.index)) ? err.length : 0;
        let error_message = (!_.isUndefined(err.response) && !_.isUndefined(err.response.data.errors)) ? _.first(_.first(_.toPairs(err.response.data.errors))[1]) : 'Có lỗi xảy ra';
        error_message = (!_.isUndefined(err.index)) ? err.message : error_message;

        throw {
          message: error_message,
          index: index,
          length: length
        };
      }
    },
    async removeMessage({ commit }, payload) {
      try{
        await kts_axios.delete('messages/' + payload.id);

        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async removeMessages({ commit }, payload) {
      try{
        await kts_axios.delete('messages/delete-multi-message', {
          params: {
            messageIdArr: payload.ids
          }
        });

        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async modifyTempMessage({ commit }, payload) {
      try{
        await kts_axios.put(`temp-message/modified`, payload);
        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getDrawByDate({ commit }, payload) {
      try{
        let result = await kts_axios.get('draws/get-by-date/' + payload.date);
        return result.data.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getReport({ commit }, payload) {
      try{
        let result = await kts_axios.get('messages/get-summary-report', {
          params: payload
        });
        return result.data.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getReportV2({ commit }, payload) {
      try{
        let result = await kts_axios.get('messages/get-summary-report-v2', {
          params: payload
        });
        return result.data.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getRegionSummaryReport({ commit }, payload) {
      try{
        let result = await kts_axios.get('messages/get-region-summary-report', {
          params: payload
        });
        return result.data.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getMultiCustomersReport({ commit }, payload) {
      try{
        let result = await kts_axios.get('messages/get-multi-customer-summary-report', {
          params: payload
        });
        return result.data.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getMessageDetail({ commit }, payload) {
      try{
        let result = await kts_axios.get('messages/' + payload.message_id);
        return result.data.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getShortcodes({ commit }) {
      try{
        let result = await kts_axios.get('shortcode', {
          params: {
            page: 1,
            limit: 1000
          }
        });
        commit('UPDATE_SHORTCODES', result.data.data.data);

        return result.data.data.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async addShortcode({ commit }, payload) {
      try{
        await kts_axios.post('shortcode', payload);
        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async editShortcode({ commit }, payload) {
      try{
        await kts_axios.patch('shortcode/' + payload.id, {
          shortcode: payload.shortcode,
          result: payload.result
        });
        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async removeShortcode({ commit }, payload) {
      try{
        await kts_axios.delete('shortcode/' + payload.id);
        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getAnnouncements({ commit }, payload) {
      try{
        let result = await kts_axios.get('announcements', {
          params: payload
        });
        return result.data.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getOverPointReport({ commit }, payload) {
      try{
        let result = await kts_axios.get('limitpoint/get-over-point-report', {
          params: payload
        });
        return result.data.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getOverPointWarningMessages({ commit }, payload) {
      try{
        let result = await kts_axios.get('limitpoint/get-over-point-warning-messages', {
          params: payload
        });
        return result.data.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getOverPointConfig() {
      try{
        let result = await kts_axios.get('user/view-over-point');
        return result.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async updateOverPointGeneralConfig({ commit }, payload) {
      try{
        await kts_axios.patch('user/save-overpoint-config', payload);
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async updateOverPointNumberConfig({ commit }, payload) {
      try{
        await kts_axios.post('limitpoint', payload);
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async removeHistoryOverPoint({ commit }, payload) {
      try{
        await kts_axios.delete('limitpoint/history-over-point/' + payload.id);
        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getFriendList({ commit }) {
      try{
        let response = await kts_axios.get('friendships/list');

        commit('UPDATE_FRIENDS', response.data.data.data);

        return response.data.data.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getFriendRequests() {
      try{
        let response = await kts_axios.get('friendships/request-list');
        return response.data.data.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async addFriend({ commit }, payload) {
      try{
        await kts_axios.post('friendships/add', payload);
        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async acceptFriend({ commit }, payload) {
      try{
        await kts_axios.post('friendships/accept', payload);
        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async denyFriend({ commit }, payload) {
      try{
        await kts_axios.post('friendships/deny?friendship_id=' + payload.friendship_id);
        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getChatMessages({ commit }, payload) {
      try{
        let response = await kts_axios.get('chat/fetch-messages/' + payload.chatroom_key);
        return response.data.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async postChatMessage({ commit }, payload) {
      try{
        let response = await kts_axios.post('chat/send-message', payload);
        return response.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async postChatImage({ commit }, payload) {
      try{
        let formData = new FormData();
        formData.append('files[]', payload.file);
        formData.append('message', payload.message);
        formData.append('chatroom_key', payload.chatroom_key);

        let response = await kts_axios.post('chat/send-message', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        return response.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async removeChatMessage({ commit }, payload) {
      try{
        await kts_axios.delete('chat/remove-message', {
          params: {
            chat_message_id: payload.chat_message_id,
            chatroom_key: payload.chatroom_key,
          }
        });
        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async removeChatMessages({ commit }, payload) {
      try{
        await kts_axios.delete('chat/remove-bulk-message', {
          data: payload
        });
        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async generateMentor({ commit }, payload) {
      try{
        let response = await kts_axios.get('user/generate-referal-code?mobile=' + payload.mobile);
        commit('UPDATE_MENTOR_CODE', {
          mobile: payload.mobile,
          mentor_code: response.data.data.mentor_code
        })
        return response.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async telegramActive({ commit }, payload) {
      try{
        let response = await kts_axios.post('telegram/verify', payload);
        return response.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async updateUserInfo({ commit }, payload) {
      try{
        await kts_axios.post('auth/update-info', payload);
        commit('UPDATE_QUESTION', payload);
        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getUserChilds({ commit }, payload) {
      try{
        let response = await kts_axios.post(`mentor/list-users/${payload.username}`, payload);
        return response.data.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? _.toPairs(err.response.data.errors)[0][1] : 'Có lỗi xảy ra';
      }
    },
    async getTransactions({ commit }, payload) {
      try{
        let url = 'tnx/list?';
        if (!_.isUndefined(payload.unit)) {
          url += `unit=${encodeURIComponent(payload.unit)}&`;
        }
        if (!_.isUndefined(payload.from_date)) {
          url += `from_date=${encodeURIComponent(payload.from_date)}&`;
        }
        if (!_.isUndefined(payload.to_date)) {
          url += `to_date=${encodeURIComponent(payload.to_date)}&`;
        }
        if (!_.isUndefined(payload.type)) {
          url += `type=${encodeURIComponent(payload.type)}&`;
        }
        if (!_.isUndefined(payload.limit)) {
          url += `limit=${encodeURIComponent(payload.limit)}&`;
        }
        let response = await kts_axios.get(url);
        return response.data.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getAgentHistories({ commit }, payload) {
      try{
        let url = `tnx/history-payment-credit?parent_username=${encodeURIComponent(payload.username)}&from_date=${encodeURIComponent(payload.from_date)}&to_date=${encodeURIComponent(payload.to_date)}`;
        let response = await kts_axios.get(url);
        return response.data.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async generateWallet() {
      try{
        await kts_axios.get(`user/get-wallet-usdt`);
        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : _.first(_.toPairs(err.response.data.errors))[1]) : 'Có lỗi xảy ra';
      }
    },
    async buyCredit({ commit }, payload) {
      try{
        return await kts_axios.post('tnx/buy-credit', payload);
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : _.first(_.toPairs(err.response.data.errors))[1]) : 'Có lỗi xảy ra';
      }
    },
    async submitWithdrawRequest({ commit }, payload) {
      try{
        return await kts_axios.post('withdraw-request/create', payload);
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : _.first(_.toPairs(err.response.data.errors))[1]) : 'Có lỗi xảy ra';
      }
    },
    async generateOTPwithdraw() {
      try{
        await kts_axios.get('withdraw-request/get-otp');

        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async generateOtpUpdateInfo() {
      try{
        await kts_axios.get('auth/get-otp-to-update-info');

        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async generateOtpBuyCredit() {
      try{
        await kts_axios.get('tnx/get-otp-buy-credit');

        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async searchUsername({ commit }, payload) {
      try{
        let response = await kts_axios.get('misc/search-user?username=' + payload.username);

        return response.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async freshMessages({ commit }, payload) {
      try{
        await kts_axios.get(`customers/fresh-messages?customer_id=${payload.customer_id}&apply_from_date=${payload.date}`);
        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getExchangePrice() {
      try{
        let response = await kts_axios.get('misc/get-exchange-prices');
        return response.data.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getBadges() {
      try{
        let response = await kts_axios.get('auth/get-badges');
        return response.data.data.badges;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async writeChildNote({ commit }, payload) {
      try{
        await kts_axios.post(`mentor/update-ref-user`, {
          ref_username: payload.username,
          note: payload.note
        });
        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async deleteMessages({ commit }, payload) {
      try{
        await kts_axios.delete(`messages/delete-by-range`, {
          params: {
            from_date: payload.from_date,
            to_date: payload.to_date
          }
        });
        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async toggleLockLogin({ commit }, payload) {
      try{
        await kts_axios.post(`mentor/login-lock`, payload);
        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getDevices({ commit }) {
      try{
        let result = await kts_axios.get('customers');

        commit('UPDATE_CUSTOMERS', result.data.data.data);

        return result.data.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async generateBotChatRoom({ commit }, payload) {
      try{
        let result = await kts_axios.post(`customers/generate-chat-room`, payload);
        return result.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getChatBotRooms({ commit }) {
      try{
        let result = await kts_axios.get('customers/list-chat-room?page=0&limit=1000');
        commit('UPDATE_BOTS', result.data.data)
        return result.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getChatRoomTempMessages({ commit }, payload) {
      try{
        let result = await kts_axios.get(`customers/list-temp-messages?page=0&limit=2000&room_id=${payload.room_id}&draw_date=${payload.draw_date}`);

        return result.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async updateChatRoomConfig({ commit }, payload) {
      try{
        await kts_axios.post(`customers/save-config-chat-room`, payload);
        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async denyChatRoomMessage({ commit }, payload) {
      try{
        await kts_axios.put(`customers/deny-temp-message`, payload);
        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getBotConfig() {
      try{
        let result = await kts_axios.get(`user/get-bot-room-schedule`);

        return result.data.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async updateBotConfig({commit}, payload) {
      try{
        await kts_axios.patch(`user/save-bot-room-schedule`, payload);

        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async removeBotRoom({ commit }, payload) {
      try{
        await kts_axios.delete(`customers/remove-chat-room`, {
          params: {
            room_id: payload.room_id
          }
        });

        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async generateBotRoomCode({ commit }, payload) {
      try{
        return await kts_axios.post(`customers/generate-chat-room-connect-code`, payload);
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async getBlockNumbers({ commit }, payload) {
      try{
        let result = await kts_axios.get(`block-number`, {
          params: payload
        });

        return result.data.data;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    async createBlockNumbers({ commit }, payload) {
      try{
        await kts_axios.post(`block-number`, payload);
        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? err.response.data.errors : 'Có lỗi xảy ra';
      }
    },
    async editBlockNumbers({ commit }, payload) {
      try{
        await kts_axios.post(`block-number/update`, payload);
        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? err.response.data.errors : 'Có lỗi xảy ra';
      }
    },
    async deleteBlockNumbers({ commit }, payload) {
      try{
        await kts_axios.delete('block-number/' + payload.id);

        return true;
      }catch(err){
        throw (!_.isUndefined(err.response.data.errors)) ? (_.isString(err.response.data.errors) ? err.response.data.errors : (_.first(_.first(_.toPairs(err.response.data.errors))[1]))) : 'Có lỗi xảy ra';
      }
    },
    /* eslint-enable */
  }
});
